// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* News Dashboard Container */
.news-dashboard {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

/* News Header */
.news-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid var(--border-color);
}

.news-header .header-content h2 {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.news-subtitle {
  color: var(--text-secondary);
  margin: 0;
  font-size: 1rem;
}

/* News Filters */
.news-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  align-items: flex-end;
}

.news-filters .filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 250px;
  flex: 1 1;
}

.news-filters .filter-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

.news-filters .filter-group input {
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.news-filters .filter-group input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.news-filters .filter-clear {
  padding: 0.75rem 1.5rem;
  background: var(--text-secondary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.news-filters .filter-clear:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* Sentiment Section - Two Column Layout */
.sentiment-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.heatmap-column, .stats-column {
  min-width: 0; /* Prevent grid blowout */
}

/* Glassomorphism Panel Style */
.glass-panel {
  background: rgba(255, 255, 255, 0.05); /* Slight tint */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Dark mode considerations for glass effect */
@media (prefers-color-scheme: dark) {
  .glass-panel {
    background: rgba(0, 0, 0, 0.2);
    border-color: rgba(255, 255, 255, 0.05);
  }
}

/* Sentiment Heatmap Container */
.sentiment-heatmap-container {
  /* Inherits glass-panel styles */
}

.heatmap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.heatmap-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* Sentiment Legend */
.sentiment-legend {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.legend-dot.negative {
  background: #ef4444;
}

.legend-dot.neutral {
  background: #71717a;
}

.legend-dot.positive {
  background: #10b981;
}

/* Heatmap Gradient Container */
.heatmap-gradient-container {
  position: relative;
  width: 100%;
  flex: 1 1; /* Take remaining height */
  display: flex;
  flex-direction: column;
}

.heatmap-gradient-container.square-aspect {
  aspect-ratio: 1/1;
  min-height: 300px;
}

.heatmap-gradient {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, 
    #ef4444dc 0%,
    #f8717186 20%,
    #71717a8e 50%,
    #34d3999f 80%,
    #10b981 100%
  );
  border-radius: 12px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden; /* Keep dots inside */
}

/* Sentiment Dots */
.sentiment-dots {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.sentiment-dot {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px double rgba(255, 255, 255, 0.397);
  cursor: pointer;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
  box-shadow: 0 5px 4px rgba(194, 147, 47, 0.2);
  z-index: 1;
}

.sentiment-dot:hover,
.sentiment-dot.hovered {
  width: 22px;
  height: 22px;
  border-width: 3px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.sentiment-dot.selected {
  width: 20px;
  height: 20px;
  border-color: #fbbf24;
  border-width: 3px;
  z-index: 5;
  animation: pulse 2s infinite;
}

/* Pulse animation for dots */
.dot-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: inherit;
  opacity: 0;
}

.sentiment-dot:hover .dot-pulse {
  animation: pulse-ring 1.5s ease-out infinite;
}

@keyframes pulse-ring {
  0% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.5);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
}

/* Heatmap Labels */
.heatmap-labels {
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.label-negative {
  color: #ef4444;
}

.label-neutral {
  color: #71717a;
}

.label-positive {
  color: #10b981;
}

/* News Statistics Card */
.news-statistics-card {
  /* Inherits glass-panel styles */
}

.stats-header {
  margin-bottom: 2rem;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 1rem;
}

.stats-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1 1;
}

.stat-item.main-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem;
  background: var(--bg-tertiary);
  border-radius: 12px;
}

.stat-value-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.stat-item .stat-value {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1;
}

.stat-item .stat-sublabel {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.stat-grid .stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.stat-grid .stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
}

@media (min-width: 1200px) {
  .stat-grid .stat-value {
    font-size: 1.8rem;
  }
}

.stat-value.positive { color: #10b981; }
.stat-value.negative { color: #ef4444; }

/* Date Time Display in Stats */
.date-time-display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
}

.date-time-display .time {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.date-time-display .date {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-distribution-bar {
  display: flex;
  height: 8px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  margin-top: auto;
}

.dist-segment {
  height: 100%;
  transition: width 0.5s ease;
}

.dist-segment.negative { background: #ef4444; }
.dist-segment.neutral { background: #71717a; }
.dist-segment.positive { background: #10b981; }

/* Heatmap Tooltip */
.heatmap-tooltip {
  position: fixed;
  background: var(--bg-primary);
  backdrop-filter: blur(10px);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  z-index: 9999;
  animation: tooltipSlideIn 0.2s ease-out;
  cursor: pointer;
  transition: all 0.2s ease;
  pointer-events: auto;
  opacity: 0.95;
}

.heatmap-tooltip:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  border-color: var(--primary);
  opacity: 1;
}

@keyframes tooltipSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.heatmap-tooltip h4 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
}

.tooltip-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
  gap: 1rem;
  flex-wrap: wrap;
}

.tooltip-source {
  font-weight: 600;
  color: var(--primary);
}

.tooltip-date {
  color: var(--text-muted);
}

.tooltip-sentiment {
  font-size: 0.95rem;
  color: var(--text-secondary);
  margin: 0;
}

.tooltip-sentiment strong {
  font-weight: 700;
  font-size: 1rem;
}

.tooltip-click-hint {
  margin: 0.75rem 0 0 0;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-color);
  font-size: 0.85rem;
  color: var(--primary);
  font-weight: 600;
  text-align: center;
}

/* News List Container */
.news-list-container {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px var(--shadow);
}

.news-list-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border-color);
}

.news-list-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* News List */
.news-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 600px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

/* Custom scrollbar */
.news-list::-webkit-scrollbar {
  width: 8px;
}

.news-list::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

.news-list::-webkit-scrollbar-thumb {
  background: var(--primary);
  border-radius: 4px;
}

.news-list::-webkit-scrollbar-thumb:hover {
  background: var(--primary-hover);
}

/* News Item */
.news-item {
  position: relative;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  padding-left: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news-item:hover {
  box-shadow: 0 6px 12px var(--shadow-hover);
  transform: translateY(-2px);
  border-color: var(--primary);
}

.news-item.selected {
  border-color: var(--primary);
  background: var(--bg-tertiary);
  box-shadow: 0 4px 8px var(--shadow);
}

/* News Item Border (color indicator) */
.news-item-border {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 10px 0 0 10px;
}

/* News Item Content */
.news-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.news-item-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1 1;
  min-width: 0;
}

.news-item-badges {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.news-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.3;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sentiment-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.news-date {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.news-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.news-link:hover {
  text-decoration: underline;
  color: var(--primary-hover);
}

/* Loading and Error States */
.news-dashboard .loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  gap: 1rem;
}

.news-dashboard .spinner {
  width: 50px;
  height: 50px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.news-dashboard .loading-spinner p {
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
}

.news-dashboard .error-message {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
  padding: 1.5rem;
  border-radius: 8px;
  border: 2px solid rgba(239, 68, 68, 0.2);
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.news-dashboard .error-message button {
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.news-dashboard .error-message button:hover {
  opacity: 0.9;
}

.news-dashboard .no-data {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);
}

.news-dashboard .no-data p {
  margin: 0.5rem 0;
  font-size: 1.1rem;
}

.news-dashboard .no-data p:first-child {
  font-size: 1.5rem;
  font-weight: 600;
}

/* Pagination */
.news-dashboard .pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding: 1.5rem;
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.news-dashboard .pagination-info {
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.news-dashboard .pagination-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.news-dashboard .pagination-controls button {
  padding: 0.6rem 1.2rem;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.news-dashboard .pagination-controls button:hover:not(:disabled) {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

.news-dashboard .pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.news-dashboard .page-info {
  font-size: 0.9rem;
  color: var(--text-primary);
  padding: 0 1rem;
  font-weight: 600;
}

.news-dashboard .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 12px;
}

/* Mobile Responsive Design */
@media (max-width: 900px) {
  .sentiment-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .news-header .header-content h2 {
    font-size: 1.5rem;
  }

  .news-filters {
    flex-direction: column;
  }

  .news-filters .filter-group {
    min-width: auto;
    width: 100%;
  }

  .news-filters .filter-clear {
    width: 100%;
  }

  .glass-panel {
    padding: 1.5rem;
  }

  .heatmap-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .sentiment-legend {
    gap: 1rem;
    flex-wrap: wrap;
  }

  .heatmap-gradient-container.square-aspect {
    min-height: 250px;
  }

  .heatmap-tooltip {
    max-width: 90%;
    padding: 1rem;
  }

  .heatmap-tooltip h4 {
    font-size: 1rem;
  }

  .news-list-container {
    padding: 1.5rem;
  }

  .news-list {
    max-height: 500px;
  }

  .news-item {
    padding: 0.75rem;
    padding-left: 1.25rem;
  }

  .news-item-content {
    flex-direction: column;
    align-items: stretch;
  }

  .news-item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .news-item-badges {
    width: 100%;
    justify-content: space-between;
  }

  .news-title {
    font-size: 0.95rem;
    white-space: normal;
  }

  .news-link {
    width: 100%;
    text-align: center;
  }

  .news-dashboard .pagination {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .news-dashboard .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }

  .news-dashboard .pagination-controls button {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .news-header .header-content h2 {
    font-size: 1.25rem;
  }

  .glass-panel {
    padding: 1rem;
  }

  .heatmap-gradient-container.square-aspect {
    min-height: 200px;
  }

  .sentiment-dot {
    width: 12px;
    height: 12px;
  }

  .sentiment-dot:hover,
  .sentiment-dot.hovered {
    width: 18px;
    height: 18px;
  }

  .news-list-container {
    padding: 1rem;
  }

  .news-item {
    padding: 0.6rem;
    padding-left: 1rem;
  }

  .news-title {
    font-size: 0.9rem;
  }
  
  .stat-item .stat-value {
    font-size: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/NewsDashboard.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA,+BAA+B;AAC/B;EACE,qCAAqC,EAAE,gBAAgB;EACvD,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE;IACE,8BAA8B;IAC9B,uCAAuC;EACzC;AACF;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAO,EAAE,0BAA0B;EACnC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,YAAY;IACZ,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;;AAEvC,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE;;AAE9C,oBAAoB;AACpB;EACE,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* News Dashboard Container */\n.news-dashboard {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n}\n\n/* News Header */\n.news-header {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.news-header .header-content h2 {\n  margin: 0 0 0.5rem 0;\n  color: var(--text-primary);\n  font-size: 2rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.news-subtitle {\n  color: var(--text-secondary);\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* News Filters */\n.news-filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.news-filters .filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 250px;\n  flex: 1;\n}\n\n.news-filters .filter-group label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.news-filters .filter-group input {\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.news-filters .filter-group input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.news-filters .filter-clear {\n  padding: 0.75rem 1.5rem;\n  background: var(--text-secondary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.news-filters .filter-clear:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n/* Sentiment Section - Two Column Layout */\n.sentiment-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.heatmap-column, .stats-column {\n  min-width: 0; /* Prevent grid blowout */\n}\n\n/* Glassomorphism Panel Style */\n.glass-panel {\n  background: rgba(255, 255, 255, 0.05); /* Slight tint */\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Dark mode considerations for glass effect */\n@media (prefers-color-scheme: dark) {\n  .glass-panel {\n    background: rgba(0, 0, 0, 0.2);\n    border-color: rgba(255, 255, 255, 0.05);\n  }\n}\n\n/* Sentiment Heatmap Container */\n.sentiment-heatmap-container {\n  /* Inherits glass-panel styles */\n}\n\n.heatmap-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.heatmap-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Sentiment Legend */\n.sentiment-legend {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.legend-dot.negative {\n  background: #ef4444;\n}\n\n.legend-dot.neutral {\n  background: #71717a;\n}\n\n.legend-dot.positive {\n  background: #10b981;\n}\n\n/* Heatmap Gradient Container */\n.heatmap-gradient-container {\n  position: relative;\n  width: 100%;\n  flex: 1; /* Take remaining height */\n  display: flex;\n  flex-direction: column;\n}\n\n.heatmap-gradient-container.square-aspect {\n  aspect-ratio: 1/1;\n  min-height: 300px;\n}\n\n.heatmap-gradient {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, \n    #ef4444dc 0%,\n    #f8717186 20%,\n    #71717a8e 50%,\n    #34d3999f 80%,\n    #10b981 100%\n  );\n  border-radius: 12px;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden; /* Keep dots inside */\n}\n\n/* Sentiment Dots */\n.sentiment-dots {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sentiment-dot {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px double rgba(255, 255, 255, 0.397);\n  cursor: pointer;\n  transform: translate(-50%, -50%);\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 4px rgba(194, 147, 47, 0.2);\n  z-index: 1;\n}\n\n.sentiment-dot:hover,\n.sentiment-dot.hovered {\n  width: 22px;\n  height: 22px;\n  border-width: 3px;\n  z-index: 10;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.sentiment-dot.selected {\n  width: 20px;\n  height: 20px;\n  border-color: #fbbf24;\n  border-width: 3px;\n  z-index: 5;\n  animation: pulse 2s infinite;\n}\n\n/* Pulse animation for dots */\n.dot-pulse {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: inherit;\n  opacity: 0;\n}\n\n.sentiment-dot:hover .dot-pulse {\n  animation: pulse-ring 1.5s ease-out infinite;\n}\n\n@keyframes pulse-ring {\n  0% {\n    opacity: 0.6;\n    transform: translate(-50%, -50%) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(2.5);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  50% {\n    transform: translate(-50%, -50%) scale(1.1);\n  }\n}\n\n/* Heatmap Labels */\n.heatmap-labels {\n  position: absolute;\n  bottom: -30px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.label-negative {\n  color: #ef4444;\n}\n\n.label-neutral {\n  color: #71717a;\n}\n\n.label-positive {\n  color: #10b981;\n}\n\n/* News Statistics Card */\n.news-statistics-card {\n  /* Inherits glass-panel styles */\n}\n\n.stats-header {\n  margin-bottom: 2rem;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 1rem;\n}\n\n.stats-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.stats-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  flex: 1;\n}\n\n.stat-item.main-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1rem;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n}\n\n.stat-value-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.stat-item .stat-value {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.stat-item .stat-sublabel {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.stat-grid .stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.stat-grid .stat-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n@media (min-width: 1200px) {\n  .stat-grid .stat-value {\n    font-size: 1.8rem;\n  }\n}\n\n.stat-value.positive { color: #10b981; }\n.stat-value.negative { color: #ef4444; }\n\n/* Date Time Display in Stats */\n.date-time-display {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.1rem;\n}\n\n.date-time-display .time {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n\n.date-time-display .date {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-distribution-bar {\n  display: flex;\n  height: 8px;\n  width: 100%;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: auto;\n}\n\n.dist-segment {\n  height: 100%;\n  transition: width 0.5s ease;\n}\n\n.dist-segment.negative { background: #ef4444; }\n.dist-segment.neutral { background: #71717a; }\n.dist-segment.positive { background: #10b981; }\n\n/* Heatmap Tooltip */\n.heatmap-tooltip {\n  position: fixed;\n  background: var(--bg-primary);\n  backdrop-filter: blur(10px);\n  border: 2px solid var(--border-color);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  z-index: 9999;\n  animation: tooltipSlideIn 0.2s ease-out;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  pointer-events: auto;\n  opacity: 0.95;\n}\n\n.heatmap-tooltip:hover {\n  transform: scale(1.02);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\n  border-color: var(--primary);\n  opacity: 1;\n}\n\n@keyframes tooltipSlideIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.heatmap-tooltip h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.4;\n}\n\n.tooltip-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.tooltip-source {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.tooltip-date {\n  color: var(--text-muted);\n}\n\n.tooltip-sentiment {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.tooltip-sentiment strong {\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.tooltip-click-hint {\n  margin: 0.75rem 0 0 0;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-color);\n  font-size: 0.85rem;\n  color: var(--primary);\n  font-weight: 600;\n  text-align: center;\n}\n\n/* News List Container */\n.news-list-container {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px var(--shadow);\n}\n\n.news-list-header {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.news-list-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* News List */\n.news-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-height: 600px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n/* Custom scrollbar */\n.news-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.news-list::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n}\n\n.news-list::-webkit-scrollbar-thumb {\n  background: var(--primary);\n  border-radius: 4px;\n}\n\n.news-list::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-hover);\n}\n\n/* News Item */\n.news-item {\n  position: relative;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  padding-left: 1.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.news-item:hover {\n  box-shadow: 0 6px 12px var(--shadow-hover);\n  transform: translateY(-2px);\n  border-color: var(--primary);\n}\n\n.news-item.selected {\n  border-color: var(--primary);\n  background: var(--bg-tertiary);\n  box-shadow: 0 4px 8px var(--shadow);\n}\n\n/* News Item Border (color indicator) */\n.news-item-border {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  border-radius: 10px 0 0 10px;\n}\n\n/* News Item Content */\n.news-item-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.news-item-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.news-item-badges {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.news-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.3;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sentiment-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.news-date {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.news-link {\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.85rem;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.news-link:hover {\n  text-decoration: underline;\n  color: var(--primary-hover);\n}\n\n/* Loading and Error States */\n.news-dashboard .loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  gap: 1rem;\n}\n\n.news-dashboard .spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid var(--border-color);\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.news-dashboard .loading-spinner p {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.news-dashboard .error-message {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n  padding: 1.5rem;\n  border-radius: 8px;\n  border: 2px solid rgba(239, 68, 68, 0.2);\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.news-dashboard .error-message button {\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.news-dashboard .error-message button:hover {\n  opacity: 0.9;\n}\n\n.news-dashboard .no-data {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-secondary);\n}\n\n.news-dashboard .no-data p {\n  margin: 0.5rem 0;\n  font-size: 1.1rem;\n}\n\n.news-dashboard .no-data p:first-child {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n/* Pagination */\n.news-dashboard .pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.news-dashboard .pagination-info {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.news-dashboard .pagination-controls {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.news-dashboard .pagination-controls button {\n  padding: 0.6rem 1.2rem;\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  cursor: pointer;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.news-dashboard .pagination-controls button:hover:not(:disabled) {\n  background: var(--primary);\n  color: white;\n  border-color: var(--primary);\n}\n\n.news-dashboard .pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.news-dashboard .page-info {\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  padding: 0 1rem;\n  font-weight: 600;\n}\n\n.news-dashboard .loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  border-radius: 12px;\n}\n\n/* Mobile Responsive Design */\n@media (max-width: 900px) {\n  .sentiment-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .news-header .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .news-filters {\n    flex-direction: column;\n  }\n\n  .news-filters .filter-group {\n    min-width: auto;\n    width: 100%;\n  }\n\n  .news-filters .filter-clear {\n    width: 100%;\n  }\n\n  .glass-panel {\n    padding: 1.5rem;\n  }\n\n  .heatmap-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .sentiment-legend {\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n\n  .heatmap-gradient-container.square-aspect {\n    min-height: 250px;\n  }\n\n  .heatmap-tooltip {\n    max-width: 90%;\n    padding: 1rem;\n  }\n\n  .heatmap-tooltip h4 {\n    font-size: 1rem;\n  }\n\n  .news-list-container {\n    padding: 1.5rem;\n  }\n\n  .news-list {\n    max-height: 500px;\n  }\n\n  .news-item {\n    padding: 0.75rem;\n    padding-left: 1.25rem;\n  }\n\n  .news-item-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .news-item-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .news-item-badges {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .news-title {\n    font-size: 0.95rem;\n    white-space: normal;\n  }\n\n  .news-link {\n    width: 100%;\n    text-align: center;\n  }\n\n  .news-dashboard .pagination {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .news-dashboard .pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .news-dashboard .pagination-controls button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .news-header .header-content h2 {\n    font-size: 1.25rem;\n  }\n\n  .glass-panel {\n    padding: 1rem;\n  }\n\n  .heatmap-gradient-container.square-aspect {\n    min-height: 200px;\n  }\n\n  .sentiment-dot {\n    width: 12px;\n    height: 12px;\n  }\n\n  .sentiment-dot:hover,\n  .sentiment-dot.hovered {\n    width: 18px;\n    height: 18px;\n  }\n\n  .news-list-container {\n    padding: 1rem;\n  }\n\n  .news-item {\n    padding: 0.6rem;\n    padding-left: 1rem;\n  }\n\n  .news-title {\n    font-size: 0.9rem;\n  }\n  \n  .stat-item .stat-value {\n    font-size: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
